// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-tab-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: 0;
    position: relative;
}

.summary-scroll-area {
    flex: 1 1;
    width: 100%;
    overflow-y: auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.summary-scroll-area--empty {
    overflow-y: hidden;
}

.summary-generate-section {
    width: 100%;
    flex-shrink: 0;
    margin-bottom: 16px;
}

.summary-generate-section .format-label,
.summary-generate-section .format-select,
.summary-generate-section .format-input {
    display: block;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    margin-left: 0;
    margin-right: 0;
}

.summary-generate-section .summary-empty-cta {
    display: block;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 0;
}

.summary-empty-state {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px;
    color: #999;
    max-width: 240px;
    margin: 0 auto;
}

.summary-empty-icon {
    font-size: 32px;
    color: #ccc;
    margin-bottom: 12px;
}

.summary-empty-title {
    margin: 0 0 4px 0;
    font-size: 15px;
    font-weight: 600;
    color: #666;
}

.summary-empty-subtitle {
    margin: 0;
    font-size: 12px;
    color: #999;
    line-height: 1.5;
}

.summary-empty-cta {
    width: 100%;
    margin-bottom: 24px;
}

.summary-action-bar {
    flex-shrink: 0;
    width: 100%;
    margin: 10px -16px -14px -16px;
    background: #fff;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.06);
    border-top: 1px solid #e0e0e0;
}

.summary-generating-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    opacity: 0.45;
    color: #777;
}

.summary-generating-state p {
    margin: 8px 0 0;
}

.summary-generating-subtitle {
    font-size: 0.9rem;
    opacity: 0.7;
}

.footer-collapse-handle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 7px 16px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 12px;
    color: #888;
    transition: color 0.2s, background-color 0.2s;
}

.footer-collapse-handle:hover {
    color: #333;
    background-color: #f9f9f9;
}

.summary-action-bar.collapsed .footer-collapse-handle {
    color: #1faeff;
    font-weight: 600;
}

.summary-action-body {
    padding: 0 16px 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.summary-action-row {
    display: flex;
    gap: 8px;
    align-items: center;
}

.summary-action-row .btn-primary {
    flex: 1 1;
}

.format-options-toggle {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    color: #666;
    font-size: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.format-options-toggle:hover {
    background: #f9f9f9;
    color: #333;
}

.format-options-toggle.active {
    border-color: #1faeff;
    color: #1faeff;
    background: rgba(31, 174, 255, 0.08);
}

.format-options-toggle:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.format-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.format-section-header .format-label {
    margin: 0;
}

.format-close-btn {
    background: none;
    border: none;
    font-size: 18px;
    line-height: 1;
    color: #999;
    cursor: pointer;
    padding: 0 4px;
}

.format-close-btn:hover {
    color: #333;
}

.ai-result {
    position: relative;
    padding: 6px 12px 12px 12px;
}

.ai-result-header {
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 32px;
    background: #f8f9fa;
    z-index: 10;
    padding: 6px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ai-result h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
    line-height: 1;
    height: 32px;
    display: flex;
    align-items: center;
}

.summary-body {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
}

.summary-body p {
    margin: 0 0 12px;
}

.summary-body h1,
.summary-body h2,
.summary-body h3,
.summary-body h4 {
    margin: 16px 0 6px;
    font-size: 14px;
    font-weight: 700;
}

.ai-result .summary-body p,
.ai-result .summary-body li,
.ai-result .summary-body h1,
.ai-result .summary-body h2,
.ai-result .summary-body h3,
.ai-result .summary-body h4 {
    font-size: 14px;
    color: #333;
}

.ai-result .summary-body h1,
.ai-result .summary-body h2,
.ai-result .summary-body h3,
.ai-result .summary-body h4 {
    font-weight: 700;
}

.summary-body p:last-child {
    margin-bottom: 0;
}

.summary-body ul {
    margin: 0 0 12px;
    padding-left: 20px;
}

.summary-body li {
    margin-bottom: 8px;
    line-height: 1.5;
}

.summary-body li:last-child {
    margin-bottom: 0;
}

.summary-body ul:last-child {
    margin-bottom: 0;
}

.summary-body h1:first-child,
.summary-body h2:first-child,
.summary-body h3:first-child,
.summary-body h4:first-child {
    margin-top: 0;
}

.copy-summary-btn {
    margin-left: auto;
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border: none;
    border-radius: 6px;
    color: #999;
    cursor: pointer;
    transition: .15s;
}

.copy-summary-btn:hover {
    background: #fff;
    color: #444;
}

.copy-summary-btn:active {
    background: rgba(0, 0, 0, 0.06);
}

.timestamp-link {
    color: #1faeff;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s;
    border-bottom: 1px solid transparent;
    margin: 1px;
}

.timestamp-link:hover {
    color: #17a0e8;
    border-bottom: 1px solid #1faeff;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/Magor/Studio/SummaryTab.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,0CAA0C;IAC1C,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;;;;IAMI,eAAe;IACf,WAAW;AACf;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,qBAAqB;AACzB","sourcesContent":[".summary-tab-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    min-height: 0;\n    position: relative;\n}\n\n.summary-scroll-area {\n    flex: 1;\n    width: 100%;\n    overflow-y: auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.summary-scroll-area--empty {\n    overflow-y: hidden;\n}\n\n.summary-generate-section {\n    width: 100%;\n    flex-shrink: 0;\n    margin-bottom: 16px;\n}\n\n.summary-generate-section .format-label,\n.summary-generate-section .format-select,\n.summary-generate-section .format-input {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.summary-generate-section .summary-empty-cta {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    margin-bottom: 0;\n}\n\n.summary-empty-state {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 24px;\n    color: #999;\n    max-width: 240px;\n    margin: 0 auto;\n}\n\n.summary-empty-icon {\n    font-size: 32px;\n    color: #ccc;\n    margin-bottom: 12px;\n}\n\n.summary-empty-title {\n    margin: 0 0 4px 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: #666;\n}\n\n.summary-empty-subtitle {\n    margin: 0;\n    font-size: 12px;\n    color: #999;\n    line-height: 1.5;\n}\n\n.summary-empty-cta {\n    width: 100%;\n    margin-bottom: 24px;\n}\n\n.summary-action-bar {\n    flex-shrink: 0;\n    width: 100%;\n    margin: 10px -16px -14px -16px;\n    background: #fff;\n    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.06);\n    border-top: 1px solid #e0e0e0;\n}\n\n.summary-generating-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    opacity: 0.45;\n    color: #777;\n}\n\n.summary-generating-state p {\n    margin: 8px 0 0;\n}\n\n.summary-generating-subtitle {\n    font-size: 0.9rem;\n    opacity: 0.7;\n}\n\n.footer-collapse-handle {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 7px 16px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 12px;\n    color: #888;\n    transition: color 0.2s, background-color 0.2s;\n}\n\n.footer-collapse-handle:hover {\n    color: #333;\n    background-color: #f9f9f9;\n}\n\n.summary-action-bar.collapsed .footer-collapse-handle {\n    color: #1faeff;\n    font-weight: 600;\n}\n\n.summary-action-body {\n    padding: 0 16px 14px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.summary-action-row {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.summary-action-row .btn-primary {\n    flex: 1;\n}\n\n.format-options-toggle {\n    flex-shrink: 0;\n    width: 34px;\n    height: 34px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: #fff;\n    color: #666;\n    font-size: 15px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.format-options-toggle:hover {\n    background: #f9f9f9;\n    color: #333;\n}\n\n.format-options-toggle.active {\n    border-color: #1faeff;\n    color: #1faeff;\n    background: rgba(31, 174, 255, 0.08);\n}\n\n.format-options-toggle:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.format-section-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.format-section-header .format-label {\n    margin: 0;\n}\n\n.format-close-btn {\n    background: none;\n    border: none;\n    font-size: 18px;\n    line-height: 1;\n    color: #999;\n    cursor: pointer;\n    padding: 0 4px;\n}\n\n.format-close-btn:hover {\n    color: #333;\n}\n\n.ai-result {\n    position: relative;\n    padding: 6px 12px 12px 12px;\n}\n\n.ai-result-header {\n    position: sticky;\n    top: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 32px;\n    background: #f8f9fa;\n    z-index: 10;\n    padding: 6px 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.ai-result h3 {\n    margin: 0;\n    font-size: 16px;\n    color: #333;\n    line-height: 1;\n    height: 32px;\n    display: flex;\n    align-items: center;\n}\n\n.summary-body {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #333;\n}\n\n.summary-body p {\n    margin: 0 0 12px;\n}\n\n.summary-body h1,\n.summary-body h2,\n.summary-body h3,\n.summary-body h4 {\n    margin: 16px 0 6px;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.ai-result .summary-body p,\n.ai-result .summary-body li,\n.ai-result .summary-body h1,\n.ai-result .summary-body h2,\n.ai-result .summary-body h3,\n.ai-result .summary-body h4 {\n    font-size: 14px;\n    color: #333;\n}\n\n.ai-result .summary-body h1,\n.ai-result .summary-body h2,\n.ai-result .summary-body h3,\n.ai-result .summary-body h4 {\n    font-weight: 700;\n}\n\n.summary-body p:last-child {\n    margin-bottom: 0;\n}\n\n.summary-body ul {\n    margin: 0 0 12px;\n    padding-left: 20px;\n}\n\n.summary-body li {\n    margin-bottom: 8px;\n    line-height: 1.5;\n}\n\n.summary-body li:last-child {\n    margin-bottom: 0;\n}\n\n.summary-body ul:last-child {\n    margin-bottom: 0;\n}\n\n.summary-body h1:first-child,\n.summary-body h2:first-child,\n.summary-body h3:first-child,\n.summary-body h4:first-child {\n    margin-top: 0;\n}\n\n.copy-summary-btn {\n    margin-left: auto;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f8f9fa;\n    border: none;\n    border-radius: 6px;\n    color: #999;\n    cursor: pointer;\n    transition: .15s;\n}\n\n.copy-summary-btn:hover {\n    background: #fff;\n    color: #444;\n}\n\n.copy-summary-btn:active {\n    background: rgba(0, 0, 0, 0.06);\n}\n\n.timestamp-link {\n    color: #1faeff;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.2s;\n    border-bottom: 1px solid transparent;\n    margin: 1px;\n}\n\n.timestamp-link:hover {\n    color: #17a0e8;\n    border-bottom: 1px solid #1faeff;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
